import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=0c4470d6&scoped=true"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"
import style0 from "./Question.vue?vue&type=style&index=0&id=0c4470d6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4470d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c4470d6')) {
      api.createRecord('0c4470d6', component.options)
    } else {
      api.reload('0c4470d6', component.options)
    }
    module.hot.accept("./Question.vue?vue&type=template&id=0c4470d6&scoped=true", function () {
      api.rerender('0c4470d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/questionConfig/subViews/preview/components/Question.vue"
export default component.exports